import { JsonObject, JsonProperty } from "typescript-json-serializer";

@JsonObject()
export class SpatialReferenceConfiguration {
    /**
     * An [image coordinate system](https://developers.arcgis.com/rest/services-reference/raster-ics.htm) defines the spatial reference used to display the image in its original coordinates without distortion, map transformations or ortho-rectification.
     *
     * [Read more...](https://developers.arcgis.com/javascript/latest/api-reference/esri-geometry-SpatialReference.html#imageCoordinateSystem)
     */
    @JsonProperty()
    declare imageCoordinateSystem: any;

    /**
     * The well-known ID of a spatial reference.
     *
     * [Read more...](https://developers.arcgis.com/javascript/latest/api-reference/esri-geometry-SpatialReference.html#wkid)
     */
    @JsonProperty()
    declare wkid: number;

    /**
     * The well-known text that defines a spatial reference.
     *
     * [Read more...](https://developers.arcgis.com/javascript/latest/api-reference/esri-geometry-SpatialReference.html#wkt)
     */
    @JsonProperty()
    declare wkt: string;

    /**
     * The well-known text of the coordinate system as defined by OGC standard for well-known text strings.
     *
     * [Read more...](https://developers.arcgis.com/javascript/latest/api-reference/esri-geometry-SpatialReference.html#wkt2)
     */
    @JsonProperty()
    declare wkt2?: string;

    constructor() {}
}
